/**
 * Source type values corresponding to the source field in location payloads.
 */
export const SOURCE_SMS = 'sms';
export const SOURCE_MMS = 'mms';
export const SOURCE_CALL = 'call';

